module.exports = __webpack_public_path__ + "img/3.62cc4e9d.png";